import { Schedule } from "../../../../types/schedule/schedule";
import { ScheduleDto } from "../../../../types/schedule/schedule-dto";
import { convertScheduleDtoToSchedule } from "../../../../utils/converter/schedule/schedule-converter";
import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    scheduleDto: ScheduleDto;
  };
}

export const setSchedulePageByDtoDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { scheduleDto } = action.payload;
  const schedule = convertScheduleDtoToSchedule(scheduleDto);

  const index = state.schedulePage.contents.findIndex((schedule: Schedule) => {
    return schedule.id === scheduleDto.id;
  });

  if (index !== -1) {
    state.schedulePage.contents[index] = schedule;
  } else {
    state.schedulePage = {
      ...state.schedulePage,
      contents: [schedule, ...state.schedulePage.contents],
    };
  }
};
